import { Box, Button, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { appsettings } from "../../app.config";
import { IClient } from "../../hooks/Client/ClientContext";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: 8,
  },
  padding: {
    padding: 8,
  },
  withoutLabel: {
    marginTop: 24,
  },
  loginContainer: {
    textAlign: "center",
  },
  buttons: {
    padding: "5px",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    backgroundImage: (props: any) => `url('${props.logo}')`,
    backgroundSize: "contain",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    display: "block",
    width: "480px",
    height: "220px",
  },
}));

const getFallbackLogo = (): string => {
  const defaultClientName = appsettings.clients["default"];
  const defaultClient = appsettings.clients[defaultClientName] as IClient;
  return defaultClient?.logo || "";
};

const getLogo = (): string => {
  try {
    const appClientString = window.sessionStorage.getItem("appclient");
    if (appClientString) {
      const appClient = JSON.parse(appClientString) as Partial<IClient>;
      if (appClient.logo) {
        return appClient.logo;
      }
    }
  } catch (error) {
    console.warn("Error reading appclient from sessionStorage", error);
  }

  return getFallbackLogo();
};

const ErrorPage = () => {
  const classes = useStyles({ logo: getLogo() });

  return (
    <Stack
      direction={"row"}
      sx={{ height: "100vh" }}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Stack
        direction="column"
        justifyContent={"stretch"}
        alignItems={"center"}
        spacing={2}
      >
        <Box component="div" className={classes.logoContainer}>
          <Box component="div" className={classes.logo}></Box>
        </Box>
        <Typography fontSize={21} fontWeight={700}>
          We're sorry, but something went wrong
        </Typography>
        <Typography fontSize={21} fontWeight={700}>
          Please try again
        </Typography>
        <Button
          type="button"
          variant="contained"
          size="large"
          sx={{ input: { cursor: "pointer" } }}
          color="primary"
          onClick={() => (window.location.href = "/login")}
        >
          <Typography>Go to Home</Typography>
        </Button>
      </Stack>
    </Stack>
  );
};

export default ErrorPage;